import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  
  .header-text {
    flex: 1;
    margin-left: 1rem;
  }
`; 